<template>
    <div>
        <div style="margin-bottom:15px">
            <el-radio-group v-model="value" size="small" @change="handleChange">
                <el-radio-button v-for="item in arrReservastate" :key="item.id" :label="item.id">{{item.name}}
                </el-radio-button>
            </el-radio-group>
        </div>

        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="labLessonName" label="课堂名称" align="center"></el-table-column>
            <el-table-column prop="lessonName" label="实验名称" align="center"></el-table-column>
            <el-table-column prop="reservationTime" label="预约时间" align="center"></el-table-column>
            <el-table-column label="预约状态" align="center">
                <template slot-scope="{row}">
                    <el-tag size="small" v-text="row.status===0?'已预约':row.status===1?'已使用':'已过期'"
                        :type="row.status===0?'success':row.status===1?'warning':'danger'"></el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="{row}">
                    <div style="margin-bottom:10px;">
                        <el-button size="mini" type="success" @click="handStartExp(row)"
                            :disabled="(row.status===1||row.status===2)">开始实验</el-button>
                    </div>
                    <div v-if="cancel(row)">
                        <el-button size="mini" type="danger" @click="handDelReserva(row)">取消预约</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div style="margin-top:15px">
            <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper"
                :total="page.total" :current-page="page.page" :page-size="page.limit"
                @current-change="handlePageChange" hide-on-single-page>
            </el-pagination>
        </div>

        <lineup-dialog
            :visible.sync="lineUpDialog"
            :exp-uid="curExp.expUid"
            :lesson-exp-uid="activeInfo.uid"
        />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import lineupDialog from "@/views/lesson/exp/components/line-up-dialog"
import { getStudyReservaQuery, getDelReserva } from '@/api/io/lab-exp-reserva-log'

export default {
  components: {
    lineupDialog
  },
    data () {
        return {
            tableData: [],
            page: {
                page: 1,
                limit: 4,
                total: 0
            },
            value: -1,
            arrReservastate: [
                { id: -1, name: '全部', tagType: '', tagText: '' },
                { id: 0, name: '已预约', tagType: 'success', tagText: '已预约' },
                { id: 1, name: '已使用', tagType: 'warning', tagText: '已使用' },
                { id: 2, name: '已过期', tagType: 'danger', tagText: '已过期' }
            ],
            curExp: {
              expUid: ""
            },
            activeInfo: {
                uid: '', // 当前选中的课程实验uid
            },
            lineUpDialog: false, // 是否显示实验排队
        }
    },
    created () {
        this.init()
    },
    computed: {
        ...mapGetters(['userInfo', 'token'])
    },
    methods: {
        handleChange () { //筛选按钮
            this.$set(this.page, 'page', 1)
            this.getStudyReservaQueryList()
        },
        handlePageChange (page) { // 分页按钮
            this.$set(this.page, "page", page);
            this.getStudyReservaQueryList()
        },
        init () {
            this.getStudyReservaQueryList()
        },
        async delReserva (id) {
            this.$set(this.page, 'page', 1)
            await getDelReserva(id).then(() => { })
            this.getStudyReservaQueryList()
        },
        handStartExp (val) {
            this.curExp = val
            this.activeInfo.uid = val.labExpUid
            let x = new Date().getTime()
            let y = new Date(val.reservationTime).getTime()
            let z = new Date(new Date(val.reservationTime).getTime() + 1 * 60 * 60 * 1000).getTime()
            if (x < y) {
                this.$message.error('实验未开始')
            } else if (x > z) {
                this.$message.error('实验已结束')
            } else if (x >= y && x <= z) {
              // 排队
              this.lineUpDialog = true
            }
        },
        cancel (item) {
            let nTime = new Date().getTime()
            let eTime = new Date(item.reservationTime).getTime()
            return nTime < eTime
        },
        handDelReserva (item) { //取消按钮
            let nTime = new Date().getTime()
            let eTime = new Date(item.reservationTime).getTime()
            this.$confirm('是否取消该预约?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                if (nTime < eTime) {
                    this.delReserva(item.id)
                } else {
                    this.$message({
                        type: 'error',
                        message: '实验已经开始,操作失败!'
                    });
                }
            })
        },
        getStudyReservaQueryList () {
            const { page, limit } = this.page
            let params = {}
            if (this.value < 0) {
                params = {
                    userId: this.userInfo.id
                }
            } else {
                params = {
                    status: this.value,
                    userId: this.userInfo.id
                }
            }
            getStudyReservaQuery(page, limit, params).then(res => {
                const { list, totalCount } = res
                this.$set(this.page, 'total', totalCount)
                this.tableData = list
                this.tableData.forEach((item, index) => {
                    item.index = index + 1 + (page - 1) * limit
                    return item
                })
            })
        }
    }
}
</script>
<style lang="less">
.lesson-lineUp-dialog {
    .el-dialog__header {
        height: 48px;
        padding: 0;
    }
    &.el-dialog--center {
        .el-dialog__body {
            text-align: center;
            padding-top: 0;
            padding-bottom: 52px;
            .lineUp-img {
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #dcdcdc;
                font-size: 0;
                position: relative;
                &::after {
                    width: 8px;
                    height: 8px;
                    content: '';
                    border-radius: 50%;
                    background-color: #00aafa;
                    position: absolute;
                    animation: lineUpIcon 2s;
                    animation-iteration-count: infinite;
                }
            }
            .lineUp-wait {
                font-size: 24px;
                line-height: 3em;
                font-weight: normal;
                span {
                    font-size: 1.5em;
                    color: #14b41e;
                    padding: 0 1em;
                }
            }
            .lineUp-btns {
                margin-top: 36px;
                .el-button {
                    min-width: 120px;
                }
            }
        }
    }
}
</style>
